import React, { forwardRef } from "react";

import { StyledCheckboxWrapper } from "./consentCheckboxField.style";
import GenericInputField, {
  TYPES,
} from "../../../genericInputFields/genericInputField";
import useSolutionForm from "../../../../hooks/useSolutionForm";

const ConsentCheckboxField = forwardRef(({ data, name, error }, ref) => {
  const { required, option } = data;
  const {
    formMethods: { register },
  } = useSolutionForm();

  return (
    <StyledCheckboxWrapper ref={ref} error={error ? 1 : 0}>
      <div key={name}>
        <GenericInputField
          type={TYPES.CHECKBOX}
          register={register}
          value={option}
          name={name}
          required={required}
        />
      </div>
      <span className="error">{error?.message || ""}</span>
    </StyledCheckboxWrapper>
  );
});
ConsentCheckboxField.displayName = "ConsentCheckboxField";

export default ConsentCheckboxField;
